import { getUserIp, getDeviceInfo } from '@/lib/utils';
import { logApiError } from '@/lib/logApiError';
import axios from 'axios';
import { AuthSession } from 'interfaces';
import { getSession, signIn } from 'next-auth/react';

const config = axios.defaults;
config.baseURL = process.env.NEXT_PUBLIC_API;
// config.headers['Content-Type'] = 'application/json';

const client = axios.create(config);

// Body Interceptor
client.interceptors.request.use(
	(config) => {
		return config;
	},
	(error) => Promise.reject(error)
);

client.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => Promise.reject(error)
);

// Auth Herder Interceptor
client.interceptors.request.use(
	async (config) => {
		try {
			const session = (await getSession()) as AuthSession;
			if (session?.accessToken) {
				config.headers['Authorization'] = `Bearer ${session.accessToken}`;
			}
		} catch (err) {
			console.error('[axiosClient] getSession failed:', err);
		}

		try {
			const ip = await getUserIp();
			config.headers['X-User-IP'] = ip;
		} catch (err) {
			console.error('[axiosClient] getUserIp failed:', err);
		}

		if (typeof window !== 'undefined') {
			const { deviceType, os } = getDeviceInfo();
			config.headers['device-type'] = deviceType;
			config.headers['device-os'] = os;
		}

		return config;
	},
	(error) => Promise.reject(error)
);

// Data Refresh token interceptor
client.interceptors.response.use(
	async (response) => {
		if (response.headers['refresh-token']) {
			const session = (await getSession()) as AuthSession;
			signIn('credentials', {
				refreshToken: response.headers['refresh-token'],
				redirect: false,
				oldSession: JSON.stringify(session),
			});
		}
		return response;
	},
	(error) => Promise.reject(error)
);

// Data Response Interceptor
client.interceptors.response.use(
	(response) => {
		return response.data;
	},
	(error) => {
		const url = error?.config?.url;
		const config = error?.config;

		// 🚨 Log del error
		// 🚫 evitar duplicados por retry
		if (
			config &&
			!config.__errorLogged &&
			![401, 501, 502, 503, 504].includes(error?.response?.status) &&
			!url?.includes('/log-error')
		) {
			config.__errorLogged = true;
			logApiError(error);
		}

		// if (
		// 	![401, 501, 502, 503, 504].includes(error?.response?.status) &&
		// 	!url?.includes('/log-error')
		// ) {
		// 	logApiError(error);
		// }

		return Promise.reject({
			...error?.response?.data,
			status: error?.response?.status,
		});
	}
);

export default client;
